import { axiosClient, TPagination } from "@/configurations/axios"
import { queryClient } from "@/configurations/react-query"
import { TQueryOptions } from "@/types/api"
import { queryOptions, useQuery } from "@tanstack/react-query"
import { TRACK_ENDPOINTS, TRACK_KEYS } from "../configs/endpoints"
import { TParamsGetTrack, TTrack } from "../types"

export const getTrackList = async (params: TParamsGetTrack) => {
  const response = await axiosClient.get<TPagination<TTrack>>(
    TRACK_ENDPOINTS.getTrack,
    { params }
  )
  return response.data
}

export const useGetTrackList = <
  TSelect = Awaited<ReturnType<typeof getTrackList>>
>(
  params: TParamsGetTrack,
  options?: TQueryOptions<typeof getTrackList, TSelect>
) => {
  return useQuery({
    queryKey: TRACK_KEYS.getTrackWithParam(params),
    queryFn: () => getTrackList(params),
    ...options
  })
}
export const getTrackListQueryOptions = (param: TParamsGetTrack) => {
  return queryOptions({
    queryKey: TRACK_KEYS.getTrackWithParam(param),
    queryFn: () => getTrackList(param)
  })
}
export const getTrackListLoader = (param: TParamsGetTrack) => {
  return queryClient.ensureQueryData(getTrackListQueryOptions(param))
}
